import React from 'react'

const AppContext = React.createContext({
  user: null
})

export default AppContext
